<template><!-- 產品關聯技術 -->
  <div>
    <h3>設定關聯技術</h3>
    <div class="h4 py-5">
      有勾選的技術才會出現在產品內頁
    </div>
    <!-- 關聯技術 -->
    <div class="d-flex pa-5 brand-100">
      <label for="filterTitleAdd"><h4 class="mr-5">添加技術</h4></label>
      <div class="d-flex my-n2 flex-grow-1">
        <div class="where-to-buy-autocomplete flex-grow-1">
          <v-autocomplete
              :items="categories"
              v-model="tempCategory"
              placeholder="搜尋技術"
              item-value="id"
              item-text="title"
              style="background: white;"
              return-object
              outlined
              dense
            >
            </v-autocomplete>
        </div>
        <div class="ml-5">
          <button
            v-if="tempCategory"
            class="btn btn-primary w-90px ml-5"
            @click="addCategory">
            新增
          </button>
          <button v-else class="btn btn-primary w-90px ml-5" disabled>
            新增
          </button>
        </div>
      </div>
    </div>
    <!-- 技術分類與底下技術 -->
    <div
      v-for="(categoryItem, i) in product.technologyCategory"
      :key="categoryItem.category">
      <div
        class="form-item d-flex h-64px align-center justify-space-between">
        <h4>{{ categoryItem.title }}</h4>
        <button class="btn square" @click="deleteCategory(i)">
          <v-icon>delete</v-icon>
        </button>
      </div>
      <!-- 技術 -->
      <div class="form-item mt-5">
        <div
          v-for="tech in categoryItem.details"
          :key="tech.id">
          <div>
            <v-checkbox v-model="tech.isChecked">
              <template v-slot:label>
                <div class="h5 ink-01-emphasis--text">
                  {{ tech.text }}
                </div>
              </template>
            </v-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  components: {
  },
  data: () => ({
    dir: 'product',
    categories: [],
    // 添加技術
    tempCategory: null,
  }),
  computed: {
    ...mapState('language', ['countries']),
    ...mapState('technology', ['technology']),
  },
  async created() {
    this.categories = await this.getTechCates();
  },
  methods: {
    ...mapActions('technology', ['getTechCates']),
    addCategory() {
      const hasCategory = this.product.technologyCategory.find((category) => category.id === this.tempCategory.id);
      if (hasCategory) {
        this.tempCategory = null;
        return;
      }
      const { id, title } = this.tempCategory;
      const tempDetails = this.tempCategory.details;
      const details = tempDetails.map((tech) => {
        tech.isChecked = false;
        return tech;
      });

      const template = {
        id, title, details,
      };
      this.product.technologyCategory.push(JSON.parse(JSON.stringify(template)));
      this.tempCategory = null;
    },
    deleteCategory(i) {
      this.product.technologyCategory.splice(i, 1);
    },
  },
};
</script>

<style></style>
